import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { boxShadow, boxSizes, fontWeights, gutterSizes } from "@gumtree/ui-library/src/base/theme";

export const ButtonsContainer = styled.div`
    grid-area: message-buttons;
    
    display: flex;
    gap: ${gutterSizes.base};
    justify-content: space-between;
    
    > * {
        width: 100%;
    }
`;

export const ButtonCss = css`
    font-weight: ${fontWeights.bold};
    border-radius: ${boxSizes.borderRadius4};
`;

export const ButtonTitle = styled.span`
    font-weight: ${fontWeights.bold};
`;

export const Spinner = styled.div<{ spinning: boolean }>`
    ${({ spinning }) =>
        spinning &&
        css`
            background: white;
            opacity: 0.5;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        `}

    position: relative;
    margin-top: 0;

    .loader-spinner {
        display: ${({ spinning }) => (spinning ? "inline-block" : "none")};
        overflow: hidden;
        position: absolute;
        top: 50%;
        left: 50%;
        animation: spinnerRotate 0.8s linear infinite;

        border-radius: 30px;
        opacity: 1;
        margin-top: -20px;
        margin-left: -20px;

        &:before {
            content: "";
            display: block;
            width: 30px;
            height: 30px;
            margin: 5px;
            border-radius: 30px;
            box-shadow: ${boxShadow.spinnerLoader};
        }
    }

    @keyframes spinnerRotate {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
`;
